<div class="main-body">
  <div  *ngIf="showHeader" [class.centered]="centerHeader" [class.left-aligned]="!centerHeader" class="main-body_header" [class.alternate-layout]="useAlternateLayout">
    <div  class="main-body_header-title-box">
      <h1 nz-title class="main-body_header_title">{{pageHeader}}</h1>
    </div>
    <div *ngIf="showPersona" class="persona-select-box">
      <app-persona-picker></app-persona-picker>
    </div>
  </div>
  <app-news-bar></app-news-bar>
  <div class="main-box" >
    <router-outlet #o="outlet"></router-outlet>
  </div>
</div>